import React, { useRef, useEffect } from "react";
import WebViewer from "@pdftron/webviewer";
import { ERROR, showToast } from "../../utils/toastUtils";
import { CustomButton } from "../../components/CustomButton";

const QuillEditorWithHTML = () => {
    const viewer = useRef(null);

    useEffect(() => {
        const initializeWebViewer = async () => {
            try {
                const instance = await WebViewer(
                    {
                        path: "/webviewer/lib", // Path to WebViewer's library
                        initialDoc: "/files/CorporateBook.pdf", // Path to your PDF file in the public folder
                        licenseKey:
                            "demo:1733487867671:7ed9464603000000009b894e6204fd0812261596d50a0f1bb266a4c3f0" // Replace with your license key
                    },
                    viewer.current
                );

                // Enable features
                instance.UI.enableFeatures([instance.UI.Feature.ContentEdit]);
                instance.UI.setToolbarGroup(instance.UI.ToolbarGroup.EDIT_TEXT);

                const { documentViewer, annotationManager } = instance.Core;

                // Example: Adding a custom save button
                instance.UI.setHeaderItems((header) => {
                    header.push({
                        type: "actionButton",
                        img: "/save-icon.svg", // Replace with a valid save icon
                        title: "Save PDF",
                        onClick: async () => {
                            try {
                                const doc = documentViewer.getDocument();
                                const xfdfString = await annotationManager.exportAnnotations();
                                const options = { xfdfString };
                                const data = await doc.getFileData(options);
                                const blob = new Blob([data], { type: "application/pdf" });
                                const link = document.createElement("a");
                                link.href = URL.createObjectURL(blob);
                                link.download = "edited-pdf-file.pdf";
                                link.click();
                            } catch (saveError) {
                                showToast(ERROR, "Failed to save the PDF. Please try again.");
                                console.error("Error during save:", saveError);
                            }
                        }
                    });
                });
            } catch (error) {
                showToast(ERROR, "Failed to load the PDF viewer. Please try again.");
                console.error("Error during WebViewer initialization:", error);
            }
        };

        initializeWebViewer();
    }, []);

    return (
        <div
            className="webviewer"
            style={{
                height: "85vh"
            }}
            ref={viewer}
        ></div>
    );
};

export default QuillEditorWithHTML;
